<template>
    <div class="template-container">
        <template v-if="id == 1">
            <div class="template-container__most-popular">
                <p class="text-white">{{ $t('listing_form.listing_template.most_popular') }}</p>
            </div>
        </template>
        <div class="container">
            <div class="template-container__content">
                <div class="select-template__info">
                    <div>
                        <template v-if="selected">
                        <h4 class="text-primary-blue">{{ $t('listing_form.listing_template.selected') }} - {{ $t(title) }}</h4>
                        </template>
                        <template v-else>
                        <h4 class="text-primary">{{ $t(title) }}</h4>
                        </template>
                        <p class="text-secondary">{{ $t(description) }}</p>
                        <a class="animated-arrow forwards hide-mobile" @click.prevent="selectTemplate(id)">
                            <span class="the-arrow -left">
                                <span class="shaft"></span>
                                </span>
                                <span class="main">
                                    <span class="text button-text text-primary">{{ $t('listing_form.listing_template.select') }}</span>
                                <span class="the-arrow -right">
                                <span class="shaft"></span>
                                </span>
                            </span>
                        </a>
                    </div>
                </div>
                <template v-if="preview">
                    <div class="select-template__preview">
                        <img class="img-fluid" :src="image" alt="listing">
                        <div class="select-template__preview__buttons">
                            <button @click.prevent="selectTemplate(id)" class="button button-l button-primary">{{ $t('listing_form.listing_template.select_template') }}</button>
                            <button @click.prevent="previewTemplate(id)" class="button button-l button-secondary">{{ $t('listing_form.listing_template.preview') }}</button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="select-template__preview cursor-pointer" @click.prevent="selectTemplate(id)">
                        <img class="img-fluid" :src="image" alt="listing">
                        <div class="select-template__preview__buttons">
                            <button class="button button-l button-primary">{{ $t('listing_form.listing_template.select_template') }}</button>
                        </div>
                    </div>
                </template>
                
                <a class="animated-arrow forwards hide-desktop mt-20" @click.prevent="selectTemplate(id)">
                    <span class="the-arrow -left">
                        <span class="shaft"></span>
                        </span>
                        <span class="main">
                            <span class="text button-text text-primary">{{ $t('listing_form.listing_template.select') }}</span>
                        <span class="the-arrow -right">
                        <span class="shaft"></span>
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            description: String,
            image: String,
            preview: {
                type: Boolean,
                default: true
            },
            selected: {
                type: Boolean,
                default: false
            },
            id: Number
        },
        mounted() {
            console.log('Component mounted.')
        },
        methods: {
            selectTemplate(id) {
                this.$emit('select-template', id);
            },
            previewTemplate(id) {
                this.$emit('preview-template', id);

                if (typeof mixpanel === 'object') {
                    mixpanel.track("Preview template");
                }
            }
        }
    }
</script>
